import { Component, OnInit } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { environment } from '../../../../../../environments/environment';
import { HistoryChangeItem } from '../../../models/history-change-item';
import { LoggingService } from '../../../../../services/logging.service';

const apiServer = environment.apiServer;

@Component({
  selector: 'app-modal-history-change',
  templateUrl: './modal-history-change.component.html',
  styleUrls: ['./modal-history-change.component.sass']
})
export class ModalHistoryChangeComponent implements OnInit {
  http: HttpClient;

  dataHistoryChange: Array<HistoryChangeItem>;
  
  constructor(private _http: HttpClient, private loggingService: LoggingService) {
    this.http = _http;
  }

  ngOnInit() {
    $('#modalHistoryChangeComponent').on('show.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1030});
    })

    $('#modalHistoryChangeComponent').on('hidden.bs.modal', function () {
      $('#modalAuctionDetail').css({'z-index': 1041});
    })
  }

  
  public loadHistoryChange(IDAuction){
    const _xid = this.loggingService.generateUUID();
    
    try {
      this.loggingService.logStart(_xid, 'App.Components.ModalHistoryChangeComponent.loadHistoryChange', null, 'Load history change started');
      
      this.dataHistoryChange = new Array<HistoryChangeItem>();

      this.http.get<Array<string>>(apiServer + "/commercial_offer/changeHistory/" + IDAuction)
      .subscribe(resp => { 
        for (let index = 0; index < resp.length; index++) {
          this.dataHistoryChange[index] = { number: resp[index]['number'], action:resp[index]['action'], autor:resp[index]['autor'], date:resp[index]['date'] }; 
        }
        this.loggingService.logFinish(_xid, 'App.Components.ModalHistoryChangeComponent.loadHistoryChange', null, 'Load history change completed');
      }, error => {
        this.loggingService.logError(_xid, 'App.Components.ModalHistoryChangeComponent.loadHistoryChange', error, null, 'Load history change failed');
      });
    } catch (_error) {
      this.loggingService.logError(_xid, 'App.Components.ModalHistoryChangeComponent.loadHistoryChange', _error, null, 'Load history change method failed');
      throw _error;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/modal-history-change/modal-history-change.component.ts